import { http, HttpResponse, delay } from 'msw';

export const googleHandlers = [
  // Address Validation API (googleApiSlice). Always reports a complete address
  // so the "missing apartment/suite" prompt never blocks the mock flow.
  // The slash is there because fetchBaseQuery joins `baseUrl` and `:validateAddress` with "/".
  http.post(
    'https://addressvalidation.googleapis.com/v1/\\:validateAddress',
    async () => {
      await delay();
      return HttpResponse.json(
        {
          result: {
            verdict: { addressComplete: true },
            address: { missingComponentTypes: [] },
          },
        },
        { status: 200 }
      );
    }
  ),
];
